import type { ProductInfoCreative } from "@/feature/ads/mock/productsInfoCreative.mock";
import { productsInfoCreativeMock } from "@/feature/ads/mock/productsInfoCreative.mock";
import { Language } from "@/utils/dictionary";
import { StepHeader } from "./StepHeader";

interface Step1SelectProductProps {
  language: Language;
  onClose: () => void;
  onSelectProduct: (product: ProductInfoCreative) => void;
}

export function Step1SelectProduct({
  language,
  onClose,
  onSelectProduct,
}: Step1SelectProductProps) {
  const products = productsInfoCreativeMock;

  return (
    <>
      <StepHeader
        title="Selecciona un Producto"
        subtitle="¿Para cuál producto quieres crear el anuncio?"
        onClose={onClose}
      />

      <div className="px-8 py-6">
        <div className="space-y-4 max-h-[50vh] overflow-y-auto pr-1">
          {products.map((product) => (
            <button
              key={`${product.product_id}-${product.website_id}`}
              type="button"
              onClick={() => onSelectProduct(product)}
              className="w-full text-left flex items-center gap-4 p-4 rounded-2xl border border-gray-200 bg-white hover:bg-gray-50 hover:border-gray-300 transition-colors"
            >
              <div className="h-12 w-12 rounded-xl overflow-hidden bg-gray-100 border border-gray-200 flex items-center justify-center flex-shrink-0">
                {product.image_url ? (
                  <img src={product.image_url} alt="" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-gray-200" />
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-lg font-semibold text-gray-900 truncate">
                  {product.name || "Producto"}
                </div>
                <div className="text-gray-500">
                  Embudo {product.name}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="px-8 py-6 border-t border-gray-100">
        <button
          type="button"
          onClick={onClose}
          className="w-full px-4 py-2.5 rounded-xl border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </>
  );
}


